var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5440_45563",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5440_45563",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4UlEQVRo3t2azU7CQBDH14+QGD3iiXrxCI/Tq7xBvaDHGt/BhvgwRqIGbmDwAdSLMZ78qLSeYJ0xs8lqSq11YTvb5JdQoLv/P7S7OzsjhIHj4WJrZ/f4rA1EQA+4Bd6BKYGv7+iziL7rCZvH4+Xm9nN//fC1v3odD8QMBMk/gteMgAOgvjThT1cb3kt/7fRtsPIBwqWihAGdFOgCjYUJh8ZrQAjCU124IQOKBDjCvkyLbwJj7CRLvEEDihugZUq8D0xU40syIKlP/x/SJYoPaBSRFgxI6nsftZT55QMaKaRFA2q0CsrcNtOsBi0YUP+EX1R8S7/nK2JAPRPNIkPlOK8hiwYkaavlGQh/a8SyASScJ75BE0nVDSSZMzZN5ZKBAaT7U3yd1iNcDKTfFoBw0il6cUUMIB3dwIihgaES72XNuAwMzL6CIoqOJEMDSFtQiMfVQCQoTuVqoCcgpr2fJ6rqoHY0kDA2MBEQ4864GkDt/A2wv4XYP8TMh9FzJyYy9ksJ3os5WpEO2S6nXQloeIeU7IN6J7ZV2G9sObG1qGVjeG7uOrG97kSCo2IppqBUismBJJ/VNOu48ANbwUR3aDzR7USpwQKLPTpLLfbIKbfZA04wTqVym1grt4npPePlNp+H5MvMTedtzwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM25);
export default __webpack_public_path__ + "static/media/m25.b9c9d53203aac5bdcf290ef1ef9352ea.svg";
export { ForwardRef as ReactComponent };